/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planshare_Code_LabelInputs */

const en_us2_planshare_code_label = /** @type {(inputs: Planshare_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan code`)
};

const pt_br2_planshare_code_label = /** @type {(inputs: Planshare_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código do plano`)
};

const pt_pt2_planshare_code_label = /** @type {(inputs: Planshare_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código do plano`)
};

/** @type {(inputs: Planshare_Code_LabelInputs) => LocalizedString} */
const es_419_planshare_code_label = en_us2_planshare_code_label;

/** @type {(inputs: Planshare_Code_LabelInputs) => LocalizedString} */
const fr_fr2_planshare_code_label = en_us2_planshare_code_label;

/** @type {(inputs: Planshare_Code_LabelInputs) => LocalizedString} */
const de_de2_planshare_code_label = en_us2_planshare_code_label;

/** @type {(inputs: Planshare_Code_LabelInputs) => LocalizedString} */
const it_it2_planshare_code_label = en_us2_planshare_code_label;

/**
* | output |
* | --- |
* | "Plan code" |
*
* @param {Planshare_Code_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_code_label = /** @type {((inputs?: Planshare_Code_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_Code_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_code_label(inputs)
	if (locale === "es-419") return es_419_planshare_code_label(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_code_label(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_code_label(inputs)
	if (locale === "de-DE") return de_de2_planshare_code_label(inputs)
	if (locale === "it-IT") return it_it2_planshare_code_label(inputs)
	return en_us2_planshare_code_label(inputs)
});
export { planshare_code_label as "planshare.code_label" }